import type { CSSProperties } from "react";
import { EXPERIENCE_CHAPTERS } from "../data/experience";
import { useExperienceStore } from "../store/experience-store";
import "./chapter-rail.css";

export function ChapterRail({ onSelect }: Readonly<{
  onSelect: (index: number) => void;
}>): React.JSX.Element {
  const chapterIndex = useExperienceStore((state) => state.chapterIndex);
  return (
    <nav className="chapter-rail" aria-label="展厅章节"
      style={{ "--active-chapter": chapterIndex } as CSSProperties}>
      <span className="chapter-rail-marker" aria-hidden="true" />
      {EXPERIENCE_CHAPTERS.map((chapter) => (
        <button type="button" key={chapter.id}
          className={chapter.index === chapterIndex ? "is-active" : ""}
          onClick={() => onSelect(chapter.index)}
          aria-label={`前往${chapter.title}`}
          aria-current={chapter.index === chapterIndex ? "step" : undefined}>
          <span className="chapter-rail-number">{chapter.marker}</span>
          <span className="chapter-rail-preview" aria-hidden="true">{chapter.title}</span>
        </button>
      ))}
    </nav>
  );
}
